import * as React from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { usePostHog } from "posthog-js/react";
import { toast } from "sonner";

import { ToolsStep } from "@/features/onboarding/components/ToolsStep";
import { api } from "@/trpc/react";

export const Route = createFileRoute(
  "/_authenticated/(wonda)/_wonda/onboarding/tools",
)({
  component: ToolsRoute,
});

function ToolsRoute() {
  const navigate = useNavigate();
  const posthog = usePostHog();

  const { data: welcomeAnswers } = api.account.getWelcomeAnswers.useQuery();
  const saveWelcomeAnswer = api.account.saveWelcomeAnswer.useMutation();

  const [selectedTools, setSelectedTools] = React.useState<string[]>(
    () => welcomeAnswers?.tools ?? [],
  );

  // Hydrate from server answers once they arrive.
  const hasHydratedRef = React.useRef(false);
  React.useEffect(() => {
    if (hasHydratedRef.current) return;
    if (!welcomeAnswers?.tools) return;
    hasHydratedRef.current = true;
    setSelectedTools(welcomeAnswers.tools);
  }, [welcomeAnswers]);

  React.useEffect(() => {
    const STORAGE_KEY = "welcome-question-viewed:tools";
    if (typeof window === "undefined") return;
    if (window.sessionStorage.getItem(STORAGE_KEY)) return;
    window.sessionStorage.setItem(STORAGE_KEY, "1");
    posthog.capture("welcome question viewed", { question: "tools" });
  }, [posthog]);

  return (
    <ToolsStep
      selectedTools={selectedTools}
      setSelectedTools={setSelectedTools}
      posthog={posthog}
      isPending={saveWelcomeAnswer.isPending}
      onContinue={(tools) => {
        saveWelcomeAnswer.mutate(
          { tools },
          {
            onSuccess: () => {
              void navigate({ to: "/onboarding/platforms" });
            },
            onError: (error) => {
              toast.error(error.message);
            },
          },
        );
      }}
    />
  );
}
